<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="legal-popup">
    <div class="content">
        <h2>{{ content.title }}</h2>
        <p>{{ content.description }}</p>
        <div class="button-wrapper">
            <a (click)="close()" class="brand-button aqua-button" title="" id="retry"><span>סגירה</span></a>
        </div>
    </div>
</div>
